import React from 'react';
import ArrowLeft from '@wix/da-ds/pkg/Icons/24x24/ArrowLeft';
import { BiData } from '@wix/da-bi/pkg/events';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import s from './BackButton.scss';
const BackButton = ({ currentDuperbrowseItem, exitDuperbrowse })=>{
    var _currentDuperbrowseItem, _currentDuperbrowseItem1, _currentDuperbrowseItem2;
    const onClick = ()=>{
        exitDuperbrowse && exitDuperbrowse();
    };
    return /*#__PURE__*/ React.createElement(IconButton, {
        className: s['root'],
        onClick: onClick,
        biData: BiData({
            evid: 304,
            link_url: (_currentDuperbrowseItem = currentDuperbrowseItem) === null || _currentDuperbrowseItem === void 0 ? void 0 : _currentDuperbrowseItem.url,
            itemid: (_currentDuperbrowseItem1 = currentDuperbrowseItem) === null || _currentDuperbrowseItem1 === void 0 ? void 0 : _currentDuperbrowseItem1.deviationId,
            typeid: (_currentDuperbrowseItem2 = currentDuperbrowseItem) === null || _currentDuperbrowseItem2 === void 0 ? void 0 : _currentDuperbrowseItem2.typeId
        }),
        size: "small",
        icon: ArrowLeft
    });
};
BackButton.displayName = 'BackButton';
export default BackButton;
